export default function programCard() {

    const dir = {
        restrict: 'E',
        replace: true,
        scope: {
            model: '=',
        },
        template: `
            <div class="card related-program-card">
                <a ng-href="{{ :: model.url }}" class="related-program-card--link">
                    <h4 ng-bind-html="::model.displayName"></h4>
                </a>
                <ul class="list-unstyled">
                    <li ng-if="model.locationsString">
                        <i class="fal fa-map-marker-alt mr-1"></i>
                        <span ng-bind-html="model.locationsString"></span>
                    </li>
                    <li ng-if="model.duration">
                        <i class="fal fa-clock mr-1"></i>
                        {{ ::model.duration }}
                    </li>
                </ul>
            </div>`
    };

    return dir;
};
